import type { TranslationCatalog } from "../TranslationManager";

export const vi: TranslationCatalog = {
  "labels.cardNumber": "Số thẻ",
  "labels.expirationDate": "Ngày hết hạn",
  "labels.cvc": "Mã bảo mật",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Số thẻ của bạn không hợp lệ.",
  "errors.invalidExpiryDate": "Ngày hết hạn thẻ của bạn không hợp lệ.",
  "errors.invalidCvc": "Mã bảo mật thẻ của bạn không hợp lệ.",
  "errors.incompleteCardNumber": "Số thẻ của bạn chưa đầy đủ.",
  "errors.incompleteExpiryDate": "Ngày hết hạn thẻ của bạn chưa đầy đủ.",
  "errors.incompleteCvc": "Mã bảo mật thẻ của bạn chưa đầy đủ.",
  "errors.expiredCard": "Thẻ của bạn đã hết hạn.",
  "aria.cardNumber": "Số thẻ",
  "aria.expirationDate": "Ngày hết hạn",
  "aria.cvc": "Mã bảo mật",
  "aria.cardInput": "Thông tin thẻ",
};
